module.exports = __webpack_public_path__ + "img/pic7.c6ad8fba.png";